// extracted by mini-css-extract-plugin
export default {"QSRAParameters":"QSRAParameters_QSRAParameters__Ag5+O","value":"QSRAParameters_value__jQS3v"};